import { motion } from 'motion/react';
import { Card } from './ui/card';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface WindChartProps {
  data: Array<{
    time: string;
    wind_speed: number;
    wind_gust: number;
  }>;
}

export function WindChart({ data }: WindChartProps) {
  const formattedData = data.map(item => ({
    time: new Date(item.time).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' }),
    'Prędkość wiatru': parseFloat(item.wind_speed.toFixed(2)),
    'Podmuchy': parseFloat(item.wind_gust.toFixed(2)),
  }));

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.7 }}
    >
      <Card className="p-6">
        <h3 className="mb-4">Wiatr - w zależności od wybranego okresu czasu</h3>
        <ResponsiveContainer width="100%" height={300}>
          <AreaChart data={formattedData}>
            <defs>
              <linearGradient id="colorWindSpeed" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#14b8a6" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#14b8a6" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorGust" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#f97316" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#f97316" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis 
              dataKey="time" 
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
              label={{ value: 'km/h', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
              }}
              formatter={(value: number) => `${value.toFixed(2)} km/h`}
            />
            <Legend />
            <Area 
              type="monotone" 
              dataKey="Prędkość wiatru" 
              stroke="#14b8a6" 
              fillOpacity={1} 
              fill="url(#colorWindSpeed)"
              animationDuration={2000}
            />
            <Area 
              type="monotone" 
              dataKey="Podmuchy" 
              stroke="#f97316" 
              fillOpacity={1} 
              fill="url(#colorGust)"
              animationDuration={2000}
              animationBegin={300}
            />
          </AreaChart>
        </ResponsiveContainer>
      </Card>
    </motion.div>
  );
}
